import {
  CUSTODIAN_MAIN_COLOR,
  CUSTODIAN_SECOND_COLOR,
  MANAGER_MAIN_COLOR,
  MANAGER_SECOND_COLOR
} from "../constants/theme";

export const setMenuColors = isManager => {
  return {
    color: isManager ? MANAGER_MAIN_COLOR : CUSTODIAN_MAIN_COLOR,
    backgroundColor: isManager ? MANAGER_SECOND_COLOR : CUSTODIAN_SECOND_COLOR
  };
};
